package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Www: ImageVector
    get() {
        if (_www != null) {
            return _www!!
        }
        _www = Builder(name = "Www", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth
                = 24.0f, viewportHeight = 24.0f).apply {
            group {
            }
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(19.565f, 10.696f)
                    lineTo(19.21f, 10.696f)
                    curveTo(18.856f, 9.201f, 17.516f, 8.087f, 15.913f, 8.087f)
                    curveTo(15.524f, 8.087f, 15.151f, 8.156f, 14.802f, 8.277f)
                    curveTo(14.018f, 6.041f, 11.894f, 4.435f, 9.391f, 4.435f)
                    curveTo(6.221f, 4.435f, 3.652f, 7.004f, 3.652f, 10.174f)
                    curveTo(3.652f, 10.373f, 3.662f, 10.571f, 3.682f, 10.765f)
                    curveTo(1.599f, 11.126f, 0.0f, 12.948f, 0.0f, 15.131f)
                    curveTo(0.0f, 17.569f, 1.996f, 19.565f, 4.435f, 19.565f)
                    lineTo(19.565f, 19.565f)
                    curveTo(22.004f, 19.565f, 24.0f, 17.569f, 24.0f, 15.131f)
                    curveTo(24.0f, 12.692f, 22.004f, 10.696f, 19.565f, 10.696f)
                    close()
                    moveTo(7.497f, 16.977f)
                    lineTo(6.845f, 16.977f)
                    lineTo(6.243f, 15.095f)
                    curveTo(6.104f, 14.655f, 5.991f, 14.264f, 5.893f, 13.801f)
                    lineTo(5.876f, 13.801f)
                    curveTo(5.78f, 14.273f, 5.657f, 14.681f, 5.518f, 15.103f)
                    lineTo(4.882f, 16.977f)
                    lineTo(4.232f, 16.977f)
                    lineTo(3.044f, 13.036f)
                    lineTo(3.776f, 13.036f)
                    lineTo(4.297f, 15.039f)
                    curveTo(4.411f, 15.478f, 4.517f, 15.885f, 4.591f, 16.293f)
                    lineTo(4.615f, 16.293f)
                    curveTo(4.705f, 15.894f, 4.835f, 15.471f, 4.965f, 15.047f)
                    lineTo(5.609f, 13.036f)
                    lineTo(6.212f, 13.036f)
                    lineTo(6.822f, 15.006f)
                    curveTo(6.967f, 15.479f, 7.082f, 15.894f, 7.172f, 16.293f)
                    lineTo(7.196f, 16.293f)
                    curveTo(7.262f, 15.894f, 7.367f, 15.478f, 7.498f, 15.014f)
                    lineTo(8.06f, 13.036f)
                    lineTo(8.768f, 13.036f)
                    lineTo(7.497f, 16.977f)
                    close()
                    moveTo(13.592f, 16.977f)
                    lineTo(12.941f, 16.977f)
                    lineTo(12.338f, 15.095f)
                    curveTo(12.199f, 14.655f, 12.086f, 14.264f, 11.988f, 13.801f)
                    lineTo(11.972f, 13.801f)
                    curveTo(11.875f, 14.273f, 11.752f, 14.681f, 11.614f, 15.103f)
                    lineTo(10.978f, 16.976f)
                    lineTo(10.326f, 16.976f)
                    lineTo(9.138f, 13.035f)
                    lineTo(9.871f, 13.035f)
                    lineTo(10.392f, 15.038f)
                    curveTo(10.505f, 15.477f, 10.612f, 15.884f, 10.685f, 16.292f)
                    lineTo(10.709f, 16.292f)
                    curveTo(10.799f, 15.893f, 10.929f, 15.47f, 11.059f, 15.046f)
                    lineTo(11.704f, 13.035f)
                    lineTo(12.306f, 13.035f)
                    lineTo(12.917f, 15.005f)
                    curveTo(13.062f, 15.478f, 13.177f, 15.893f, 13.267f, 16.292f)
                    lineTo(13.291f, 16.292f)
                    curveTo(13.355f, 15.893f, 13.462f, 15.477f, 13.592f, 15.013f)
                    lineTo(14.154f, 13.035f)
                    lineTo(14.863f, 13.035f)
                    lineTo(13.592f, 16.977f)
                    close()
                    moveTo(19.686f, 16.977f)
                    lineTo(19.035f, 16.977f)
                    lineTo(18.433f, 15.095f)
                    curveTo(18.294f, 14.655f, 18.181f, 14.264f, 18.083f, 13.801f)
                    lineTo(18.066f, 13.801f)
                    curveTo(17.969f, 14.273f, 17.846f, 14.681f, 17.708f, 15.103f)
                    lineTo(17.072f, 16.976f)
                    lineTo(16.421f, 16.976f)
                    lineTo(15.233f, 13.035f)
                    lineTo(15.965f, 13.035f)
                    lineTo(16.487f, 15.038f)
                    curveTo(16.6f, 15.477f, 16.706f, 15.884f, 16.779f, 16.292f)
                    lineTo(16.803f, 16.292f)
                    curveTo(16.893f, 15.893f, 17.023f, 15.47f, 17.153f, 15.046f)
                    lineTo(17.798f, 13.035f)
                    lineTo(18.4f, 13.035f)
                    lineTo(19.01f, 15.005f)
                    curveTo(19.156f, 15.478f, 19.271f, 15.893f, 19.361f, 16.292f)
                    lineTo(19.385f, 16.292f)
                    curveTo(19.449f, 15.893f, 19.556f, 15.477f, 19.686f, 15.013f)
                    lineTo(20.248f, 13.035f)
                    lineTo(20.957f, 13.035f)
                    lineTo(19.686f, 16.977f)
                    close()
                }
            }
        }
        .build()
        return _www!!
    }

private var _www: ImageVector? = null
